import * as Styles from './styles';

import P from 'prop-types';

export const AplicativoComponent = ({ chave, transportadora }) => {
  return (
    <Styles.Container>
      <h5>Baixe o APP pelo QR Code abaixo:</h5>
      <div
        className="p-1"
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          justifyItems: 'center',
          textAlign: 'center',
        }}
      >
        <img className="img-fluid" src="/apk/prod.png" alt="" style={{ width: '50%' }} />
      </div>
      <a href="/apk/canhoto.apk">Clique aqui para fazer o download do aplicativo!</a>
      <hr />
      <h5 className="mt-4 mb-3">Instruções</h5>
      <ul>
        <li className="mb-2">Instale o APK no seu dispositivo</li>
        <li className="mb-2">Acesse o APP usando o token de acesso criado (Chave e Transportadora)</li>
        <div style={{ marginLeft: '5%' }}>
          <li className="mb-2">
            Chave: <b style={{ marginLeft: '1%' }}>{chave}</b>
          </li>
          <li className="mb-2">
            Transportadora: <b style={{ marginLeft: '1%' }}>{transportadora}</b>
          </li>
        </div>
        <li className="mb-2">Autorize o acesso do aplicativo a câmera e localização</li>
        <li className="mb-2">Pronto seu acesso foi configurado com êxito</li>
      </ul>
    </Styles.Container>
  );
};

AplicativoComponent.propTypes = {
  chave: P.number,
  transportadora: P.number,
};
